<router-outlet></router-outlet> <app-loader *ngIf="showLoader"></app-loader>
